import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

/**
 * Functional Component that represents a data layer selector list item in the side bar
*/
const LayerSelector = props => {
  const {
    checked,
    description,
    shortdescription,
    source,
    sourceurl,
    fullcitation,
    id,
    name,
    onChange,
    openLightbox,
    onZoomBtnClick,
  } = props;

  // data that gets passed to the lightbox
  const payload = {
    name,
    description,
    shortdescription,
    source,
    sourceurl,
    fullcitation,
  };

  const btnZoomClasses = classNames({
    'btn-icon-style': true,
    'btn-zoom-to': true,
    disabled: !checked,
  });

  return (
    <div className="LayerSelector">
      <div className="mdc-form-field">
        <div className="checkbox-label mdc-checkbox">
          <input
            id={id}
            type="checkbox"
            className="mdc-checkbox__native-control"
            tabIndex="0"
            checked={checked}
            onChange={() => onChange(id)}
          />
          <div className="mdc-checkbox__background">
            <svg className="mdc-checkbox__checkmark" viewBox="0 0 24 24">
              <path
                className="mdc-checkbox__checkmark__path"
                fill="none"
                stroke="white"
                d="M1.73,12.91 8.1,19.28 22.79,4.59"
              />
            </svg>
            <div className="mdc-checkbox__mixedmark" />
          </div>
        </div>

        <label className="mdc-checkbox-label" htmlFor={id}>
          {name}
        </label>

        <div className="layer-selector-btns">
          <button className={btnZoomClasses} disabled={!checked} onClick={() => onZoomBtnClick(id)}>
            <span />
          </button>
          <button
            className="btn-icon-style btn-read-more"
            onClick={() => openLightbox('dataLayer', payload)}
          >
            <span />
          </button>
        </div>
      </div>

      <div className="description-read-more">
        <p className="description">{shortdescription || '*needs a short description*'}</p>
      </div>
    </div>
  );
};

LayerSelector.propTypes = {
  checked: PropTypes.bool.isRequired,
  description: PropTypes.string,
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  openLightbox: PropTypes.func.isRequired,
  onZoomBtnClick: PropTypes.func.isRequired,
  shortdescription: PropTypes.string,
  source: PropTypes.string,
  sourceurl: PropTypes.string,
  fullcitation: PropTypes.string,
};

LayerSelector.defaultProps = {
  description: 'needs a long description',
  shortdescription: 'some descriptive text here',
  source: 'info about the source',
  sourceurl: '',
  fullcitation: 'fullcitation text',
};

export default LayerSelector;



// WEBPACK FOOTER //
// ./src/components/LayerSelector.jsx